import { ErrorMessages, PlannerEcsSystem, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
/**
 * Handles that corner fittings are added/removed when a frame is moved to/from a corner
 */
export class CornerFittingsSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'CornerFittingsSystem', ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
        this.coreApi = coreApi;
        this.cornerFittigsProduct = null;
    }
    setMarketProducts(marketProducts) {
        this.cornerFittigsProduct =
            marketProducts.find(product => product.type === ProductType.BILLY_CORNER_FITTING) || null;
    }
    onAdd(entity, newComponent) {
        if (this.cornerFittigsProduct &&
            this.coreApi.entities.isProductType(entity, ProductType.BILLY_FRAME_WITH_SHELVES_ASM) &&
            this.placedInCorner(newComponent)) {
            this.addCornerFitting();
        }
    }
    onUpdate(entity, oldComponent, newComponent) {
        if (!this.cornerFittigsProduct ||
            !this.coreApi.entities.isProductType(entity, ProductType.BILLY_FRAME_WITH_SHELVES_ASM) ||
            this.placedInCorner(oldComponent) === this.placedInCorner(newComponent)) {
            return;
        }
        if (this.placedInCorner(newComponent)) {
            this.prepareFrameForCornerFitting(entity);
            this.addCornerFitting();
        }
        if (this.placedInCorner(oldComponent)) {
            this.removeCornerFitting();
        }
    }
    onRemove(entity, oldComponent) {
        if (this.cornerFittigsProduct &&
            this.coreApi.entities.isProductType(entity, ProductType.BILLY_FRAME_WITH_SHELVES_ASM) &&
            this.placedInCorner(oldComponent)) {
            this.removeCornerFitting();
        }
    }
    placedInCorner(guestConnection) {
        return (guestConnection.highestPriorityConnection &&
            guestConnection.highestPriorityConnection.guestConnector.key === 'wall-corner');
    }
    addCornerFitting() {
        const cornerFittingEntityLeft = this.coreApi
            .getServices()
            .productManager.createEntity(this.cornerFittigsProduct.coreProductId);
        const cornerFittingEntityRight = this.coreApi
            .getServices()
            .productManager.createEntity(this.cornerFittigsProduct.coreProductId);
        if (cornerFittingEntityLeft && cornerFittingEntityRight) {
            this.coreApi.entities.placementService.forcePlaceEntity(cornerFittingEntityLeft);
            this.coreApi.entities.placementService.forcePlaceEntity(cornerFittingEntityRight);
        }
    }
    removeCornerFitting() {
        const cornerFittingsInScene = this.coreApi.entities.getByProductType(ProductType.BILLY_CORNER_FITTING);
        if (cornerFittingsInScene.length >= 2) {
            this.coreApi.entities.delete(cornerFittingsInScene[0]);
            this.coreApi.entities.delete(cornerFittingsInScene[1]);
        }
    }
    prepareFrameForCornerFitting(entity) {
        const extension = this.coreApi.entities.findDescendantWithOneOfProductTypes(entity, [
            ProductType.BILLY_FRAME_EXTENSION
        ]);
        const secondExtension = extension &&
            this.coreApi.entities.findDescendantWithOneOfProductTypes(extension, [
                ProductType.BILLY_FRAME_EXTENSION
            ]);
        const doorsOnFrame = this.coreApi.entities
            .getFrameDescendants(entity)
            .filter(entity => entity.hasComponent(ComponentIds.DOOR_COMPONENT_ID));
        const doorsOnExtension = (extension &&
            this.coreApi.entities
                .getFrameDescendants(extension)
                .filter(entity => entity.hasComponent(ComponentIds.DOOR_COMPONENT_ID))) ??
            [];
        const entitiesToDelete = [...doorsOnFrame, ...doorsOnExtension, secondExtension];
        const canUndo = this.coreApi.history.canUndo();
        if (canUndo && entitiesToDelete.length > 0) {
            this.coreApi.emit.onPlacementAttempt(ErrorMessages.BillyMoveFrameToCornerDeleteExtAndDoor);
        }
        entitiesToDelete?.forEach(e => e && this.coreApi.entities.delete(e));
    }
}
//# sourceMappingURL=CornerFittingsSystem.js.map